import RendezvousJS from "rendezvous-js";
const rendezvous = RendezvousJS({ company: "nx" });

const dataLayerPush = (data) => {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push(data);
};

// list of actions that can be taken in the application
const definitions = {
  login: () => {
    dataLayerPush({
      event: "userLogin",
      userType: "customer",
    });
  },
  loginAsAdmin: () => {
    dataLayerPush({
      event: "userLogin",
      userType: "admin",
    });
  },
  navigation: (data) => {
    // pageview();
    rendezvous.event("pageviewVirtual", data.fullPath, data.meta.title);
  },
  triggerSampleAlert: () => {
    dataLayerPush({
      event: "triggerSampleAlert",
    });
  },
  ecommerceImpression: (data) => {
    dataLayerPush({
      ecommerce: {
        currencyCode: "USD",
        impressions: data.products.map((prod, p) => {
          return {
            name: prod.name,
            id: prod.id,
            brand: "Nexcess",
            position: p + 1,
            category: prod.type,
            variant: prod.size,
            list: data?.list,
          };
        }),
      },
    });
  },
  addToCart: (cartData) => {
    rendezvous.event("addToCart", cartData);
  },
  checkoutStarted: (cartData) => {
    rendezvous.event("checkout", cartData, rendezvous.constants.NEXCESS.CHECKOUT_STEPS.STARTED);
  },
  checkoutTermsAgreement: (cartData) => {
    rendezvous.event(
      "checkout",
      cartData,
      rendezvous.constants.NEXCESS.CHECKOUT_STEPS.TERMS_AGREEMENT
    );
  },
  checkoutSignup: (cartData) => {
    rendezvous.event("checkout", cartData, rendezvous.constants.NEXCESS.CHECKOUT_STEPS.SIGNUP);
  },
  checkoutPlanDetails: (cartData) => {
    rendezvous.event(
      "checkout",
      cartData,
      rendezvous.constants.NEXCESS.CHECKOUT_STEPS.PLAN_DETAILS
    );
  },
  checkoutBillingInfo: (cartData) => {
    rendezvous.event(
      "checkout",
      cartData,
      rendezvous.constants.NEXCESS.CHECKOUT_STEPS.BILLING_INFO
    );
  },
  checkoutPurchaseInitiated: (cartData) => {
    rendezvous.event(
      "checkout",
      cartData,
      rendezvous.constants.NEXCESS.CHECKOUT_STEPS.PURCHASE_INITIATED
    );
  },
  checkoutPurchaseCompleted: ({ orderData, cartData, userData }) => {
    rendezvous.event("purchaseCompleted", orderData, cartData, userData);
  },
};

const scriptDefinitions = {
  gtm: () => {
    if (process.env.VUE_APP_GTM_ID) {
      loadGtm(process.env.VUE_APP_GTM_ID);
    }
  },
};

const analytics = {
  namespaced: true,
  state: {
    rendezvous,
  },
  mutations: {},
  actions: {
    send(context, payload) {
      const definition = definitions[payload.name];

      if (definition) {
        definition(payload.data);
      }
    },
    loadScript(context, payload) {
      const definition = scriptDefinitions[payload];

      if (definition) {
        definition(payload);
      }
    },
  },
  getters: {},
};

export default analytics;
